var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    staticClass: "d-flex align-items-center w-25 mb-2"
  }, [_vm._v(" User Id: "), _c('BaseInputText', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.debugStarted,
      "label": "User Id"
    },
    model: {
      value: _vm.debugUserId,
      callback: function callback($$v) {
        _vm.debugUserId = $$v;
      },
      expression: "debugUserId"
    }
  })], 1), _c('BaseButton', {
    attrs: {
      "disabled": !_vm.debugUserId
    },
    on: {
      "click": function click($event) {
        _vm.debugStarted = !_vm.debugStarted;
      }
    }
  }, [_vm._v(_vm._s(_vm.debugStarted ? 'Stop impersonating' : 'Start impersonating'))]), _vm.debugStarted ? _c('MyInfoView', {
    attrs: {
      "debug-mode": "yes",
      "debug-user-id": parseInt(_vm.debugUserId)
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }